import React from "react";
import "./../../pages/css/LandingFooter.css";
import {
  FaFacebook,
  FaPhone,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";
import { AiFillTikTok } from "react-icons/ai";
import nlogo from "./../../assets/images/nhdcl_main_logo.png";
import glogo from "./../../assets/images/new_gyalsung_nobg.png";

const LandingFooter = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Brand & About */}
        <div className="footer-section brand-section">
          <div className="footer-brand-logos">
            <img src={nlogo} alt="NHDCL" className="footer-logo" />
            <div className="footer-logo-divider"></div>
            <img
              src={glogo}
              alt="Gyalsung"
              className="footer-logo gyalsung-footer-logo"
            />
          </div>
          <p className="footer-about">
            National Housing Development Corporation Limited's integrated
            Facility Management System dedicated to operational excellence
            across all Gyalsung Academies.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="footer-title">Navigation</h3>
          <ul className="footer-links">
            <li>
              <a
                href="https://www.nhdcl.bt/"
                target="_blank"
                rel="noopener noreferrer"
              >
                NHDCL Bhutan
              </a>
            </li>
            <li>
              <a
                href="https://gyalsung.bt/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Gyalsung Academy
              </a>
            </li>
            <li>
              <a
                href="https://erp.nhdcl.bt/#login"
                target="_blank"
                rel="noopener noreferrer"
              >
                ERP System
              </a>
            </li>
            <li>
              <a href="/login">Staff Portal</a>
            </li>
          </ul>
        </div>

        {/* Contact info */}
        <div className="footer-section" id="contact-support-section">
          <h3 className="footer-title">Contact Support</h3>
          <div className="footer-contact">
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <FaPhone />
              </div>
              <div>
                <p className="contact-label">Head Office</p>
                <p>323147 / 332735</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <FaMapMarkerAlt />
              </div>
              <div>
                <p className="contact-label">Regional Offices</p>
                <p>Phuntsholing: 05-252649</p>
                <p>Samdrupjongkhar: 07-251252</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>© 2026 NHDCL Facility Management System. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
